import { Image, Text, TouchableOpacity, View } from "react-native";
import { FormattedMessage } from "react-intl";
import React, { useEffect, useState } from "react";
import HeaderTabs from "../../components/HeaderTabs";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { If, Then, Else, Switch, Case } from "react-if";
import styles from "./styles";
import GoBackButton from "../../components/GoBackButton";

const MyQualification = ({ navigation }) => {
  const [level, setLevel] = useState(1);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    const levelUser = await AsyncStorage.getItem("level");
    setLevel(parseInt(levelUser));
  }

  const renderStep = (stepLevel) => {
    const isConcluded = level >= stepLevel;
    const stepStyle = isConcluded
      ? styles.stepConcluded
      : styles.stepNoConcluded;
    const lineStyle = isConcluded
      ? styles.stepLineConcluded
      : styles.stepLineNoConcluded;

    return (
      <View style={styles.contentTimeline}>
        <View style={stepStyle}>
          <Text style={styles.numberLevel}>{stepLevel}</Text>
        </View>
        <If condition={stepLevel < 3}>
          <View style={lineStyle} />
        </If>
      </View>
    );
  };

  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="myQualification.headerTitleMeuNivel" />}
        subtitle={<FormattedMessage id="myQualification.headerSubTitle" />}
      />
      <View style={styles.container}>
        <View style={styles.outsideEdge}>
          <View style={styles.innerEdge}>
            <Image
              source={require("../../../assets/imgs/medal.png")}
              style={styles.imgMedal}
            />
            <Text style={styles.level}>
              <Switch>
                <Case condition={level === 1}>1</Case>
                <Case condition={level === 2}>2</Case>
                <Case condition={level === 3}>3</Case>
              </Switch>
            </Text>
          </View>
        </View>

        <View style={styles.contentTimeline}>
          {[1, 2, 3].map((stepLevel) => (
            <If key={stepLevel} condition={level >= stepLevel}>
              <Then>{renderStep(stepLevel)}</Then>
              <Else>{renderStep(stepLevel)}</Else>
            </If>
          ))}
        </View>
        <Text style={styles.descriptionLevel}>
          <FormattedMessage id="myQualification.txtVoceNivelX" />
          <Switch>
            <Case condition={level === 1}>1</Case>
            <Case condition={level === 2}>2</Case>
            <Case condition={level === 3}>3</Case>
          </Switch>
        </Text>

        <View style={styles.contentBtn}>
          <TouchableOpacity
            style={styles.button}
            onPress={() => navigation.navigate("LevelUpdate")}
          >
            <View>
              <Text style={styles.textBtn}>
                <FormattedMessage id="myQualification.txtAtualizacaoNivel" />
              </Text>
            </View>
          </TouchableOpacity>
          <GoBackButton />
        </View>
      </View>
    </>
  );
};

export default MyQualification;
